import type { Feature } from '@risksmart-app/shared/organisation/Feature';
import { createContext } from 'react';

export const FeaturesContext = createContext<Feature[] | null>(null);
